(function (root) {
  'use strict';

  // Display arithmetic must match Shopify's server-side Buy X Get Y discount.
  const calculateOffer = (variants, ids, mode, discountCents = 499) => {
    const selected = ids.slice(0, mode === 2 ? 2 : 1).map((id) =>
      variants.find((variant) => String(variant.id) === String(id))
    );
    const complete = selected.length === mode && selected.every((variant) => variant?.available);
    const subtotal = selected.reduce((sum, variant) => sum + (variant?.price || 0), 0);
    const discount = mode === 2 && complete
      ? Math.min(Math.max(0, discountCents), ...selected.map((variant) => variant.price)) : 0;
    const quantities = new Map();
    if (complete) selected.forEach((variant) => quantities.set(variant.id, (quantities.get(variant.id) || 0) + 1));
    return { complete, subtotal, discount, total: subtotal - discount,
      items: Array.from(quantities, ([id, quantity]) => ({ id, quantity })) };
  };

  const init = (section, variants, formatMoney, selectVariant) => {
    const widget = section.querySelector('[data-ten-love-duo]');
    if (!widget) return null;
    const form = section.querySelector('[data-reign-product-form]');
    const variantInput = section.querySelector('[data-reign-variant-input]');
    const quantityInput = section.querySelector('[data-reign-qty-input]');
    const initial = variants.find((variant) => String(variant.id) === String(variantInput.value)) || variants[0];
    const ids = [initial.id, null];
    const discountKnown = widget.dataset.discountKnown !== 'false';
    const discountCents = discountKnown ? Number(widget.dataset.discountCents) : 0;
    const fields = widget.querySelector('[data-duo-fields]');
    const slots = Array.from(widget.querySelectorAll('[data-duo-slot]'));
    const optionInputs = Array.from(section.querySelectorAll('[data-reign-option]'));
    const modeInputs = Array.from(widget.querySelectorAll('[data-duo-mode]'));
    const buttons = [section.querySelector('[data-reign-atc]'), section.querySelector('[data-reign-sticky-submit]')].filter(Boolean);
    let mode = 1;
    let activeSlot = 0;
    let displayingSlot = false;
    const find = (id) => variants.find((variant) => String(variant.id) === String(id));
    const setText = (selector, value) => {
      const element = widget.querySelector(selector);
      if (element) element.textContent = value;
    };
    const setField = (name, value) => {
      const input = document.createElement('input');
      input.type = 'hidden'; input.name = name; input.value = value;
      fields.appendChild(input);
    };

    const render = () => {
      const offer = calculateOffer(variants, ids, mode, discountCents);
      const first = find(ids[0]) || initial;
      const pair = calculateOffer(variants, [first.id, ids[1] || first.id], 2, discountCents);
      const pending = form.dataset.reignSubmitting === 'true';
      // Browsers can restore radio values independently of the controller on Back navigation.
      modeInputs.forEach((input) => { input.checked = Number(input.value) === mode; });
      setText('[data-duo-single-price]', formatMoney(first.price));
      setText('[data-duo-pair-price]', formatMoney(pair.total));
      setText('[data-duo-base-price]', formatMoney(pair.subtotal));
      setText('[data-duo-saving]', discountKnown ? `Save ${formatMoney(pair.discount)}` : 'Save at checkout');
      const basePrice = widget.querySelector('[data-duo-base-price]');
      if (basePrice) basePrice.hidden = !discountKnown;
      widget.querySelector('[data-duo-selection]').hidden = mode !== 2;
      slots.forEach((slot, index) => {
        const variant = find(ids[index]);
        slot.setAttribute('aria-pressed', String(index === activeSlot));
        slot.setAttribute('aria-label', `Set ${index + 1}: ${variant?.title || 'choose a design'}. Tap to edit.`);
        slot.querySelector('[data-duo-name]').textContent = variant?.title || 'Choose a design';
        slot.querySelector('[data-duo-edit]').textContent = index === activeSlot ? 'Choosing below' : 'Tap to change';
        const image = slot.querySelector('[data-duo-image]');
        const source = variant?.featured_image?.src || variant?.featured_media?.preview_image?.src;
        image.hidden = !source;
        if (source) image.src = source;
        slot.querySelector('[data-duo-placeholder]').hidden = Boolean(source);
      });
      setText('[data-duo-hint]', mode === 2 && offer.complete
        ? `Your duo is ready. Editing set ${activeSlot + 1} below.`
        : `Choose a design below for set ${activeSlot + 1}. Mix two styles or double up on your favorite.`);
      fields.replaceChildren();
      variantInput.disabled = mode === 2;
      if (quantityInput) { quantityInput.value = '1'; quantityInput.disabled = mode === 2; }
      if (mode === 2) offer.items.forEach((item, index) => {
        setField(`items[${index}][id]`, item.id);
        setField(`items[${index}][quantity]`, item.quantity);
      });
      const buyNow = form.dataset.reignBuyNow === 'true';
      const label = mode === 2
        ? (offer.complete ? (buyNow ? 'Buy duo now' : 'Add duo to bag') : 'Choose your second set')
        : (buyNow ? 'Buy now' : 'Add to cart');
      buttons.forEach((button) => {
        if (pending) return;
        button.disabled = !offer.complete;
        const labelNode = button.querySelector('[data-reign-atc-label]');
        if (labelNode) labelNode.textContent = label; else button.textContent = label;
      });
      section.querySelectorAll('[data-reign-atc-price], [data-reign-sticky-price]').forEach((node) => {
        node.textContent = formatMoney(offer.total);
        node.hidden = !offer.complete || pending || (mode === 2 && !discountKnown);
      });
      const stickyVariant = section.querySelector('[data-reign-sticky-variant]');
      const selectionText = mode === 2
        ? `${find(ids[0])?.title || 'Set 1'} + ${find(ids[1])?.title || 'choose set 2'}` : first.title;
      if (stickyVariant) stickyVariant.textContent = selectionText;
      const selection = section.querySelector('[data-tl-purchase-selection]');
      const count = section.querySelector('[data-tl-purchase-count]');
      if (selection) selection.textContent = selectionText;
      if (count) {
        const adhesive = section.querySelector('.tl-set-inclusions') ? ' / Free adhesive included' : '';
        count.textContent = mode === 2 && !offer.complete
          ? 'Select your second design above to continue.'
          : `${mode} ${mode === 1 ? 'set' : 'sets'}${adhesive}`;
      }
      if (mode === 2 && !ids[activeSlot]) optionInputs.forEach((input) => {
        input.checked = false;
        input.closest('[data-reign-style-choice]')?.classList.remove('is-selected');
      });
      const selectedLabel = section.querySelector('[data-reign-selected-option]');
      if (selectedLabel && mode === 2 && !ids[activeSlot]) selectedLabel.textContent = `Choose set ${activeSlot + 1}`;
    };

    const showSlot = (index) => {
      activeSlot = index;
      const variant = find(ids[index]);
      if (variant) {
        displayingSlot = true;
        selectVariant(variant);
        displayingSlot = false;
      }
      render();
    };
    modeInputs.forEach((input) => input.addEventListener('change', () => {
      mode = Number(input.value);
      showSlot(mode === 2 && !ids[1] ? 1 : 0);
    }));
    slots.forEach((slot, index) => slot.addEventListener('click', () => showSlot(index)));
    widget.querySelector('[data-duo-match]').addEventListener('click', () => { ids[1] = ids[0]; showSlot(1); });
    // A repeated tap on an already-selected radio must still fill the empty second slot.
    optionInputs.forEach((input) => input.addEventListener('click', () => {
      if (mode === 2 && input.checked && !ids[activeSlot]) {
        const variant = variants.find((candidate) => candidate.options[0] === input.value);
        if (variant) { ids[activeSlot] = variant.id; render(); }
      }
    }));
    form.addEventListener('submit', (event) => {
      if (!calculateOffer(variants, ids, mode, discountCents).complete) {
        event.preventDefault(); event.stopImmediatePropagation();
        widget.querySelector('[data-duo-hint]').textContent = 'Please choose both designs before continuing.';
      }
    }, true);
    const note = section.querySelector('.reign-product__note');
    if (note && widget.dataset.offerNote) note.textContent = widget.dataset.offerNote;
    section.classList.add('tl-duo-ready');
    widget.hidden = false;
    render();
    root.addEventListener?.('pageshow', () => { if (section.isConnected) render(); });
    return {
      sync(variant) {
        if (variant && !displayingSlot) ids[activeSlot] = variant.id;
        render();
      },
      render,
    };
  };
  root.TenLoveDuo = { calculateOffer, init };
  if (typeof module !== 'undefined' && module.exports) module.exports = { calculateOffer, init };
})(typeof window !== 'undefined' ? window : {});
